/******************************************************************
 * Archivo : client/src/queries/fetchAllPermissions.js
 * Proyecto: CB30
 * Módulo  : Usuarios - Permisos
 * Proceso : Consulta de todos los permisos
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query PermissionsQuery {
    permissions {
      id
      code
      module
      functionality
      label
      description
      order
      active
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/fetchAllPermissions.js